<div class="header">
  <h1>Entire window scrolling demo</h1>
  <a class="navbar-link" routerLink="/">Home</a>
</div>

<div class="top-visible">
  Top visible: {{ (datasource.adapter.firstVisible$ | async)?.$index }}
</div>

<div *ngIf="init()">
  <div *uiScroll="let item of datasource" style="height: 20px">
    <b>{{ item.text }}</b>
    <span [style.color]="item.color">
      {{ item.data }}
    </span>
  </div>
</div>
